<template>
    <div :class="{'inline-block': !isSVG}">
        <v-icon :color="iconColor" v-if="icon && icon.substring(0,4) === 'mdi-'" v-bind="$attrs">
            {{ icon }}
        </v-icon>
        <eva-icon v-else-if="icon && icon.substring(0,4) === 'eva-'" :name="icon.substring(4)" :fill="iconColor" v-bind="$attrs" />
        <svg-icon v-else-if="icon && icon.substring(0,5) === 'icon-'" :color="iconColor" :icon="icon" v-bind="$attrs"></svg-icon>
    </div>
</template>

<script>
import SvgIcon from './SvgIcon';

/**
 * Component SmartIcon.vue
 *
 * @module SmartIcon
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/SmartIcon.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'SmartIcon',
  props: {
    iconColor: {
      type: String,
      default: () => 'rgba(0, 0, 0, 0.87)'
    },
    icon : {
      type: String,
    }
  },
  components: { SvgIcon },
  computed: {
    isSVG() {
      return !!(this.icon && this.icon.substring(0,5) === 'icon-')
    }
  }
}
</script>